import { FORM_ID, IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'

import { calculateFileLink } from 'core/classes/helpers/saveFiles'

import { TSelectVersionMode } from '../types/Types'

interface IGetEntityDependsOnSelectMode {
  onImageUpload: (fieldName: string, file: File, fileName: string) => void
  selectedVersion: IELTData
  mode: TSelectVersionMode
  versionName?: string
  versionSerialNumber?: number
}

export const getEntityDependsOnSelectMode = async ({
  onImageUpload,
  selectedVersion,
  mode,
  versionName,
  versionSerialNumber,
}: IGetEntityDependsOnSelectMode) => {
  if (mode === 'clone') {
    const { EntryId, UID, ...clonedData } = selectedVersion
    if (clonedData.Logo) {
      const link = calculateFileLink({
        formId: FORM_ID,
        fileName: clonedData.Logo,
        fieldName: 'Logo',
        entryId: EntryId,
        UID,
      })
      const blob = await fetch(link).then((r) => r.blob())
      const file = new File([blob], clonedData.Logo, { type: 'image/png' })
      onImageUpload('Logo', file, clonedData.Logo)
    }
    if (clonedData.Picture) {
      const link = calculateFileLink({
        formId: FORM_ID,
        fileName: clonedData.Picture,
        fieldName: 'Picture',
        entryId: EntryId,
        UID,
      })
      const blob = await fetch(link).then((r) => r.blob())
      const file = new File([blob], clonedData.Picture, { type: 'image/png' })
      onImageUpload('Picture', file, clonedData.Picture)
    }
    return {
      ...clonedData,
      Version: versionSerialNumber,
      ClonedFromVersion: selectedVersion.Version,
      VersionName: versionName,
    } as IELTData
  }
  return selectedVersion
}
